import { Injectable, inject } from '@angular/core';
import { WindowReferenceService } from './window-reference.service';

type WindowWithDataLayer = Window & {
  dataLayer?: any[];
};

@Injectable({
  providedIn: 'root',
})
export class DataLayerService {
  private readonly windowRef: WindowReferenceService = inject(WindowReferenceService);
  private window?: WindowWithDataLayer;

  constructor() {
    this.window = this.windowRef.nativeWindow;
  }

  private pingHome(obj: any) {
    if (obj && this.window?.dataLayer) {
      this.window.dataLayer.push(obj);
    }
  }

  logUserId(userId: string) {
    const hit = {
      event: 'login',
      user_id: userId,
    };
    this.pingHome(hit);
  }
}
